import { forwardRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { InputSwitch as InputSwitchBase } from 'prime-ng-old/inputswitch';
import * as i0 from "@angular/core";
import * as i1 from "../input-ref/input-ref.directive";
import * as i2 from "../input-ref/form-control-name";
import * as i3 from "@angular/common";
const _c0 = (a0, a1, a2, a3, a4) => ({
  "p-input-switch p-component": true,
  "p-input-switch-checked": a0,
  "p-disabled": a1,
  "p-focus": a2,
  "p-readonly": a3,
  "size-small": a4
});
function UiInputSwitchComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 6)(1, "small");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.labels[ctx_r1.checked() ? 1 : 0]);
  }
}
function UiInputSwitchComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "input", 3, 0);
    i0.ɵɵlistener("change", function UiInputSwitchComponent_Conditional_0_Template_input_change_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputChange($event));
    })("focus", function UiInputSwitchComponent_Conditional_0_Template_input_focus_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocus());
    })("blur", function UiInputSwitchComponent_Conditional_0_Template_input_blur_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵlistener("click", function UiInputSwitchComponent_Conditional_0_Template_span_click_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClick($event));
    });
    i0.ɵɵelement(5, "span", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(6, UiInputSwitchComponent_Conditional_0_Conditional_6_Template, 3, 1, "label", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(13, _c0, ctx_r1.checked(), ctx_r1.disabled, ctx_r1.focused, ctx_r1.readonly, ctx_r1.size === "small"))("ngStyle", ctx_r1.style);
    i0.ɵɵattribute("aria-checked", ctx_r1.checked());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r1.checked())("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("id", ctx_r1.inputId)("name", ctx_r1.name)("tabindex", ctx_r1.tabindex);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("@blockInitialRenderAnimation", undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@toggle", ctx_r1.getToggleState());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.labels ? 6 : -1);
  }
}
export const INPUTSWITCH_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UiInputSwitchComponent),
  multi: true
};
export let UiInputSwitchComponent = /*#__PURE__*/(() => {
  class UiInputSwitchComponent extends InputSwitchBase {
    set _labels(labels) {
      if (typeof labels === 'string') this.labels = [labels, labels];else this.labels = labels;
    }
    set _label(label) {
      this.labels = [label, label];
    }
    // @ViewChild('input') input!: ElementRef;
    constructor(cd) {
      super(cd);
      // protected prevToggleState = 'initial';
      // protected prevCheckedState = null;
      this.size = 'default';
      this.modelValue = false;
      this.labels = null;
    }
    getToggleState() {
      const newState = this.modelValue === null ? 'initial' : this.checked() ? 'enabled' : 'disabled';
      // this.prevToggleState = newState;
      return newState;
    }
    onInputChange(event) {
      if (!this.readonly) {
        const inputChecked = event.target.checked;
        this.updateModel(event, inputChecked);
      }
    }
    updateModel(event, value) {
      this.modelValue = value ? this.trueValue : this.falseValue;
      this.onModelChange(this.modelValue);
      this.onChange.emit({
        originalEvent: event,
        checked: this.modelValue
      });
    }
    static {
      this.ɵfac = function UiInputSwitchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiInputSwitchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiInputSwitchComponent,
        selectors: [["ui-input-switch"]],
        inputs: {
          size: "size",
          modelValue: [0, "model", "modelValue"],
          _labels: [0, "labels", "_labels"],
          _label: [0, "label", "_label"]
        },
        features: [i0.ɵɵProvidersFeature([INPUTSWITCH_VALUE_ACCESSOR]), i0.ɵɵHostDirectivesFeature([i1.InputRefDirective, {
          directive: i2.FormControlNameStandalone,
          inputs: ["formControlName", "formControlNameStandalone"]
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [["input", ""], [3, "ngClass", "ngStyle"], [1, "p-hidden-accessible"], ["type", "checkbox", 3, "change", "focus", "blur", "checked", "disabled"], ["role", "checkbox", 1, "p-input-switch-slider", 3, "click"], [1, "p-input-switch-button"], [1, "p-input-switch-label"]],
        template: function UiInputSwitchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UiInputSwitchComponent_Conditional_0_Template, 7, 19);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.checked() != null ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i3.NgClass, i3.NgStyle, FormsModule],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center}.p-input-switch[_ngcontent-%COMP%]{position:relative;display:inline-block;width:2.8em;height:1.55em}.p-input-switch.size-small[_ngcontent-%COMP%]{font-size:.8em}.p-input-switch-slider[_ngcontent-%COMP%]{position:absolute;cursor:pointer;inset:0;transition:background-color .3s;background-color:#ddd;border:.05em solid #aaa;border-radius:.75em;box-sizing:border-box}.p-input-switch-button[_ngcontent-%COMP%]{position:absolute;display:block;height:1.2em;width:1.2em;left:.15em;bottom:.125em;border-radius:50%;background-color:#fff;border:.05em solid #aaa;box-sizing:border-box;transform:translate(0)}.p-input-switch-checked[_ngcontent-%COMP%]   .p-input-switch-button[_ngcontent-%COMP%]{transform:translate(1.2em)}.p-input-switch-label[_ngcontent-%COMP%]{margin-left:5px}.p-input-switch.p-disabled[_ngcontent-%COMP%]   .p-input-switch-slider[_ngcontent-%COMP%], .p-input-switch-readonly[_ngcontent-%COMP%]   .p-input-switch-slider[_ngcontent-%COMP%]{cursor:default}.p-input-switch[_ngcontent-%COMP%]   .p-input-switch-slider[_ngcontent-%COMP%]{background-color:var(--inputSwitchOffBgColor);border-color:var(--inputSwitchOffBorderColor)}.p-input-switch[_ngcontent-%COMP%]   .p-input-switch-slider[_ngcontent-%COMP%]   .p-input-switch-button[_ngcontent-%COMP%]{background-color:var(--inputSwitchOffHandleBgColor);border-color:var(--inputSwitchOffHandleBgColor);transition:background-color .3s}.p-input-switch.p-input-switch-checked[_ngcontent-%COMP%]   .p-input-switch-button[_ngcontent-%COMP%]{background-color:var(--inputSwitchOnBgColor);border-color:var(--inputSwitchOnBgColor)}.p-input-switch.p-input-switch-focus[_ngcontent-%COMP%]   .p-input-switch-slider[_ngcontent-%COMP%]{border-color:var(--inputSwitchOnBorderColor)}.p-input-switch[_ngcontent-%COMP%]:not(.p-disabled):hover   .p-input-switch-slider[_ngcontent-%COMP%]{background-color:var(--inputSwitchOnBgColor);border-color:var(--inputSwitchHoverBorderColor)}.p-input-switch.p-input-switch-checked[_ngcontent-%COMP%]   .p-input-switch-slider[_ngcontent-%COMP%]{background-color:var(--inputSwitchOnBgColor);border-color:var(--inputSwitchOnBorderColor)}.p-input-switch.p-input-switch-checked[_ngcontent-%COMP%]   .p-input-switch-slider[_ngcontent-%COMP%]   .p-input-switch-button[_ngcontent-%COMP%]{background-color:var(--inputSwitchOnHandleBgColor);border-color:var(--inputSwitchOnHandleBgColor)}.p-input-switch.p-input-switch-checked[_ngcontent-%COMP%]:not(.p-disabled):hover   .p-input-switch-slider[_ngcontent-%COMP%]{background-color:var(--inputSwitchOnBgColor)}.p-input-switch.p-input-switch-checked.p-input-switch-focus[_ngcontent-%COMP%]   .p-input-switch-slider[_ngcontent-%COMP%]{background-color:var(--inputSwitchOnBgColor);border-color:var(--inputSwitchOnBorderColor)}"],
        data: {
          animation: [trigger('toggle', [state('disabled', style({
            transform: 'translateX(0)'
          })), state('enabled', style({
            transform: 'translateX(1.2em)'
          })), transition('enabled <=> disabled', animate('.2s')), transition(':enter', [])]), trigger("blockInitialRenderAnimation", [transition(":enter", [])])]
        },
        changeDetection: 0
      });
    }
  }
  return UiInputSwitchComponent;
})();